<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <trend-related-chart-wrapper
        :data-list="dataList"
        :unit-prop="unitProp"
        :download-name="downloadName"
        :factors="filterFactors"
        show-list
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import TrendRelatedChartWrapper from '../../../../components/Data/TrendRelatedChartWrapper'

export default {
  name: 'StatisticalAnalysisBCEC',
  routeInfo: {
    label: 'BC和EC',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  data () {
    return {
      query: {
        factorIds: [],
        isMultipleIntegral: true
      }
    }
  },
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, TrendRelatedChartWrapper},
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '3507')),
      new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '6401'))
    ],
    downloadName: () => 'BC和EC'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/17BC-EC/index.vue